module.exports = __webpack_public_path__ + "img/China-2-hover.a931234d.jpg";